
import _ from 'lodash'
import { COPY } from './copy'
import { isFormerIchra } from '~/util/former-ichra'

export default {
    props: {
        label: { type: String, default: COPY.s1.searchLabel },
        placeholder: { type: String, default: COPY.s1.searchPlaceholder },
        noMatchesText: { type: String, default: COPY.s1.noMatchesClient },
        excludeIds: { type: Array, default: () => [] },
    },
    data () {
        return {
            COPY,
            q: '',
            open: false,
            picked: false,
            loading: false,
            limit: 5,
            items: [],
            total: 0,
            recents: [],
            recentsLoaded: false,
        }
    },
    computed: {
        showingRecents () {
            return this.q.trim().length < 2
        },
        recentRows () {
            return this.recents.filter(r => !this.excludeIds.includes(r.id)).slice(0, 5)
        },
        rows () {
            return this.showingRecents ? this.recentRows : this.items
        },
        moreCount () {
            return this.showingRecents ? 0 : Math.max(this.total - this.items.length, 0)
        },
    },
    created () {
        // Per-instance debounce — an options-level _.debounce is shared across
        // all mounted CrmSearch instances (primary + attendee boxes).
        this.debouncedSearch = _.debounce(() => this.search(), 250)
    },
    methods: {
        isFormerIchra,
        formatDob (dob) {
            return dob ? this.$moment(dob).format('MM/DD/YYYY') : ''
        },
        onFocus () {
            this.open = true
            if (!this.recentsLoaded) this.loadRecents()
            if (!this.showingRecents) this.debouncedSearch()
        },
        onInput (v) {
            this.q = v
            if (this.picked) {
                this.picked = false
                this.$emit('reset')
            }
            this.open = true
            this.limit = 5 // cap resets when the query changes
            this.debouncedSearch()
        },
        async loadRecents () {
            this.recentsLoaded = true
            const resp = await this.$api.getRecentClients()
            this.recents = (resp && resp.items) || []
        },
        async search () {
            if (this.showingRecents) return
            this.loading = true
            try {
                const resp = await this.$api.searchClients({
                    query: this.q.trim(),
                    size: this.limit,
                    exclude_ids: this.excludeIds,
                    // Former Benefit Bay clients (closed 2026-10-01) stay findable
                    // here so the agent gets the partnership message instead of a
                    // silent no-match. No checkbox: the scheduler is staff-only.
                    former_ichra: true,
                })
                this.items = (resp && resp.items) || []
                this.total = (resp && resp.total) || 0
            } finally {
                this.loading = false
            }
        },
        showMore () {
            this.limit += 5
            return this.search()
        },
        pick (r) {
            this.picked = true
            this.q = `${r.first_name || ''} ${r.last_name || ''}`.trim()
            this.open = false
            this.items = []
            this.$emit('pick', r)
        },
    },
}
